import { useLang, tx } from "@/context/LangContext";
import { T } from "@/data/content";
import { useEffect, useState } from "react";
import { Home, Undo2, ArrowUp } from "lucide-react";

export default function HomeButton({ page, onNav, inline = false }) {
    const { lang } = useLang();
    if (page === "home") return null;
    return (
        <button
            data-testid="home-btn"
            onClick={() => onNav("home")}
            aria-label={tx(lang, T.pagenav.home)}
            className={`flex items-center gap-3 border border-white/20 bg-ink/70 px-4 py-3 font-mono text-[10px] tracking-[0.3em] text-cream/80 backdrop-blur-md transition-all duration-500 hover:border-violet hover:bg-violet hover:text-cream ${
                inline ? "" : "fixed bottom-6 left-5 z-[65] md:bottom-8 md:left-10"
            }`}
        >
            <Home size={13} />
            {tx(lang, T.pagenav.home)}
        </button>
    );
}

export function BackButton({ onBack }) {
    const { lang } = useLang();
    return (
        <button
            data-testid="back-btn"
            data-cursor="RETOUR"
            onClick={onBack}
            aria-label={tx(lang, T.pagenav.back)}
            className="flex items-center gap-3 border border-gold/40 bg-ink/70 px-4 py-3 font-mono text-[10px] tracking-[0.3em] text-gold backdrop-blur-md transition-all duration-500 hover:bg-gold hover:text-ink"
        >
            <Undo2 size={13} />
            {tx(lang, T.pagenav.back)}
        </button>
    );
}

/* flèche « haut de page » — apparaît quand on a scrollé (mobile compris) */
export function TopButton() {
    const { lang } = useLang();
    const [show, setShow] = useState(false);
    useEffect(() => {
        const onScroll = () => setShow(window.scrollY > 600);
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);
    if (!show) return null;
    return (
        <button
            data-testid="top-btn"
            data-cursor="HAUT"
            onClick={() => {
                window.__lenis?.scrollTo(0, { duration: 1.2, force: true });
                window.scrollTo({ top: 0, behavior: "smooth" });
            }}
            aria-label={tx(lang, T.pagenav.top)}
            title={tx(lang, T.pagenav.top)}
            className="flex h-11 w-11 items-center justify-center border border-violet/50 bg-ink/70 text-violet backdrop-blur-md transition-all duration-500 hover:bg-violet hover:text-cream"
        >
            <ArrowUp size={14} />
        </button>
    );
}
